import { render, staticRenderFns } from "./WeddingEventImageCaptionForm.vue?vue&type=template&id=26c26894"
import script from "./WeddingEventImageCaptionForm.vue?vue&type=script&lang=ts"
export * from "./WeddingEventImageCaptionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports